module.exports = __webpack_public_path__ + "aa1544d5f7f433875d77bb8cf349fa1d.svg";